"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _ThumbnailBox = _interopRequireDefault(require("./ThumbnailBox"));
var _FileTypeContainer = _interopRequireDefault(require("./FileTypeContainer"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _IconButton = require("./IconButton");
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: {
      borderRadius: 0,
      cursor: "pointer",
      padding: theme.spacing(0.5, 2),
      "&:hover": {
        backgroundColor: _pittaModules.LightColors.primary["6"]
      }
    },
    rootActive: {
      backgroundColor: _pittaModules.LightColors.primary["6"]
    },
    wrap: {
      display: "flex"
    },
    contentWrap: _objectSpread({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1,
      whiteSpace: "nowrap",
      maxWidth: "calc(100% - 124px)"
    }, theme.direction === "rtl" ? {
      paddingRight: theme.spacing(1)
    } : {
      paddingLeft: theme.spacing(1)
    }),
    time: {
      display: "flex"
    },
    exp: {
      display: "flex",
      alignItems: "center"
    },
    buttonWrap: {
      display: "flex",
      alignItems: "center"
    },
    menuButton: {
      width: 30,
      minWidth: 30,
      height: 30,
      "&:active": {
        color: "black"
      }
    },
    menuBtnIcon: {
      // color: LightColors.primary["3"],
    },
    menuBtnIconActive: {
      // color: LightColors.primary["1"],
    },
    menuListIcon: _objectSpread({
      display: "flex",
      alignItems: "center",
      minHeight: 24,
      minWidth: 18,
      fontSize: 18
    }, theme.direction === "rtl" ? {
      paddingLeft: theme.spacing(0.5)
    } : {
      paddingRight: theme.spacing(0.5)
    }),
    checkBox: {
      color: _pittaModules.LightColors.primary["4"],
      padding: 3,
      "&.Mui-checked": {
        color: _pittaModules.LightColors.primary["7"]
      }
    }
  });
});
var FileList = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var img = props.img,
    time = props.time,
    exp = props.exp,
    locationType = props.locationType,
    eventCode = props.eventCode,
    active = props.active,
    fileType = props.fileType,
    selectMode = props.selectMode,
    progressIndicator = props.progressIndicator,
    progress = props.progress,
    loading = props.loading,
    checked = props.checked,
    playing = props.playing,
    onMore = props.onMore,
    onChecked = props.onChecked,
    t = props.t;
  var classes = useStyle();
  var theme = (0, _core.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    dir: theme.direction,
    elevation: 0,
    className: (0, _clsx.default)(classes.root, active && classes.rootActive)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrap
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ThumbnailBox.default, {
    locationType: locationType,
    img: img,
    active: playing,
    progressIndicator: progressIndicator,
    progress: progress,
    loading: loading
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentWrap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.time
  }, loading && /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: 135,
    height: 21
  }), !loading && /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "SmallBold"
  }, time)), /*#__PURE__*/_react.default.createElement(_FileTypeContainer.default, {
    fileType: fileType,
    eventCode: eventCode,
    loading: loading,
    isAI: _lodash.default.includes(_pittaModules.AI_EVENTS, eventCode),
    t: t
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.exp
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    htmlColor: _pittaModules.LightColors.primary["3"],
    category: "Default",
    variant: "Caption"
  }, exp && "Exp: ".concat(exp)))), !loading && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonWrap
  }, selectMode ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: checked,
    onChange: onChecked,
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    className: classes.checkBox,
    inputProps: {
      "aria-label": "primary checkbox"
    }
  })) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    color: "secondary",
    ref: ref,
    className: classes.menuButton,
    onClick: onMore
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, {
    className: classes.menuBtnIcon
  }))))));
});
var _default = FileList;
exports.default = _default;